import { render, staticRenderFns } from "./purothersubject.vue?vue&type=template&id=7514f65f&scoped=true&"
import script from "./purothersubject.vue?vue&type=script&lang=js&"
export * from "./purothersubject.vue?vue&type=script&lang=js&"
import style0 from "./purothersubject.vue?vue&type=style&index=0&id=7514f65f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7514f65f",
  null
  
)

export default component.exports